import React from 'react'
import { Modal } from 'antd'
import { Button } from '@surecompanies/core_components'
import {
  ModalSubtitle,
  SyncEmptyState,
  SyncFooterSummary,
  SyncModalFooter,
  SyncModalScroll,
} from './ClientBillingProfileManagement.styles'
import { HubspotSyncNewCompanyRows } from './HubspotSyncNewCompanyRows'
import type { useHubspotSyncNewCompanies } from './useHubspotSyncNewCompanies'

interface HubspotSyncNewCompaniesModalProps {
  open: boolean
  state: ReturnType<typeof useHubspotSyncNewCompanies>
  onClose: () => void
}

/**
 * HubSpot companies we hold no billing profile for. Each is submitted on its
 * own row, so there is no footer action here beyond closing.
 */
const HubspotSyncNewCompaniesModal = ({
  open,
  state,
  onClose,
}: HubspotSyncNewCompaniesModalProps) => (
  <Modal
    open={open}
    onCancel={onClose}
    title="New companies"
    footer={null}
    destroyOnClose
    width={640}
    style={{ maxWidth: 'calc(100vw - 32px)' }}
  >
    <ModalSubtitle>
      {state.canGrant
        ? 'HubSpot found these companies with no billing profile. Add a due day, check the payment type, then submit each one. Ticked addresses also get access to the funding portal, and anyone without an account is emailed an invitation.'
        : 'HubSpot found these companies with no billing profile. Add a due day, check the payment type, then submit each one.'}
    </ModalSubtitle>

    {state.rows.length === 0 ? (
      <SyncEmptyState>Nothing left to set up.</SyncEmptyState>
    ) : (
      <SyncModalScroll>
        <HubspotSyncNewCompanyRows state={state} />
      </SyncModalScroll>
    )}

    <SyncModalFooter>
      <SyncFooterSummary>{state.hint}</SyncFooterSummary>
      <Button onClick={onClose}>Close</Button>
    </SyncModalFooter>
  </Modal>
)

export { HubspotSyncNewCompaniesModal }
